<form [formGroup]="addressForm">
    <div class="mt-1 md:mt-4 grid grid-cols-1 gap-y-1 md:gap-y-6 sm:grid-cols-2 sm:gap-x-4">
        <div class="sm:col-span-2">
            <div class="mt-1">
                <select
                    class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                    [ngClass]="{ 'border-red-500': addressForm.get('countryCode')?.invalid && addressForm.get('countryCode')?.touched }"
                    formControlName="countryCode" id="countryCode"
                    autocomplete="country">
                    <option value="" disabled>Select Country/Region</option>
                    <option *ngFor="let country of availableCountries" [ngValue]="country.code">
                        {{ country.name }}
                    </option>
                </select>
            </div>
            <div
                *ngIf="
                    (addressForm.get('countryCode')?.errors || addressForm.get('countryCode')?.invalid) &&
                    addressForm.get('countryCode')?.touched
                "
                class="text-red-500 text-xs mt-1"
                >
                Error: Select a Country/Region.
            </div>
        </div>
        <!-- First Name -->
        <div>
            <div class="mt-1">
                <input
                    type="text"
                    id="firstName"
                    placeholder="First name"
                    name="firstName"
                    formControlName="firstName"
                    class="block w-full border-gray-300 rounded-md shadow-sm
                        focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                    [ngClass]="{ 'border-red-500': addressForm.get('firstName')?.invalid && addressForm.get('firstName')?.touched }"
                    [readonly]="readonlyFullName"
                />
            </div>
            <div
                *ngIf="
                    (addressForm.get('firstName')?.errors || addressForm.get('firstName')?.invalid) &&
                    addressForm.get('firstName')?.touched
                "
                class="text-red-500 text-xs mt-1"
                >
                Error: Enter a first name.
            </div>
        </div>

        <!-- Last Name -->
        <div>
            <div class="mt-1">
                <input
                type="text"
                id="lastName"
                placeholder="Last name"
                name="lastName"
                formControlName="lastName"
                class="block w-full border-gray-300 rounded-md shadow-sm
                    focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                [ngClass]="{ 'border-red-500': addressForm.get('lastName')?.invalid && addressForm.get('lastName')?.touched }"
                [readonly]="readonlyFullName"
                />
            </div>
            <div
                *ngIf="
                    (addressForm.get('lastName')?.errors || addressForm.get('lastName')?.invalid) &&
                    addressForm.get('lastName')?.touched
                "
                class="text-red-500 text-xs mt-1"
                >
                Error: Enter a last name.
            </div>
        </div>

        <div>
            <div class="mt-1">
                <input
                    type="text"
                    name="streetLine1"
                    id="streetLine1"
                    placeholder="Street address"
                    formControlName="streetLine1"
                    autocomplete="street-address"
                    class="block w-full border-gray-300 rounded-md shadow-sm
                        focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                    [ngClass]="{ 'border-red-500': addressForm.get('streetLine1')?.invalid && addressForm.get('streetLine1')?.touched }"
                />
            </div>
            <div
                *ngIf="
                    (addressForm.get('streetLine1')?.errors || addressForm.get('streetLine1')?.invalid) &&
                    addressForm.get('streetLine1')?.touched
                "
                class="text-red-500 text-xs mt-1"
                >
                Error: Enter a street address.
            </div>
        </div>

        <div>
            <div class="mt-1">
                <input
                    type="text"
                    name="streetLine2"
                    id="streetLine2"
                    placeholder="Street address 2 (optional)"
                    formControlName="streetLine2"
                    class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500
            sm:text-sm"
                />
            </div>
        </div>

        <div>
            <div class="mt-1">
                <input
                    type="text"
                    name="city"
                    id="city"
                    placeholder="City"
                    autocomplete="address-level2"
                    formControlName="city"
                    class="block w-full border-gray-300 rounded-md shadow-sm
                        focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                    [ngClass]="{ 'border-red-500': addressForm.get('city')?.invalid && addressForm.get('city')?.touched }"
                />
            </div>
            <div
                *ngIf="
                    (addressForm.get('city')?.errors || addressForm.get('city')?.invalid) &&
                    addressForm.get('city')?.touched
                "
                class="text-red-500 text-xs mt-1"
                >
                Error: Enter a city.
            </div>
        </div>

        <div *ngIf="displayState">
            <div class="mt-1">
                <select
                    *ngIf="availableStates.length > 0"
                    id="province"
                    formControlName="province"
                    class="block w-full border-gray-300 rounded-md shadow-sm
                        focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                    [ngClass]="{
                        'border-red-500': addressForm.get('province')?.invalid && addressForm.get('province')?.touched,
                        'text-gray-500': isProvincePlaceholder
                    }"
                >
                    <option value="" disabled>
                        Select {{stateNaming}}</option>
                    <option *ngFor="let state of availableStates" [ngValue]="state.code">
                        {{ state.name }}
                    </option>
                </select>
                <input
                    *ngIf="availableStates.length === 0"
                    [placeholder]="stateNaming + ' (optional)'"
                    type="text"
                    name="province"
                    id="province"
                    formControlName="province"
                    autocomplete="address-level1"
                    class="block w-full border-gray-300 rounded-md shadow-sm
                        focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                    [ngClass]="{ 'border-red-500': addressForm.get('province')?.invalid && addressForm.get('province')?.touched }"
                />
            </div>
            <div
                *ngIf="
                    (addressForm.get('province')?.errors || addressForm.get('province')?.invalid) &&
                    addressForm.get('province')?.touched
                "
                class="text-red-500 text-xs mt-1"
                >
                Error: Enter a {{stateNaming}}.
            </div>
        </div>

        <div>
            <div class="mt-1">
                <input
                    type="text"
                    name="postalCode"
                    id="postalCode"
                    [placeholder]="postalCodeNaming"
                    formControlName="postalCode"
                    autocomplete="postal-code"
                    class="block w-full border-gray-300 rounded-md shadow-sm
                        focus:ring-primary-500 focus:border-primary-500sm:text-sm"
                    [ngClass]="{ 'border-red-500': addressForm.get('postalCode')?.invalid && addressForm.get('postalCode')?.touched }"
                />
            </div>
            <div
                *ngIf="
                    (addressForm.get('postalCode')?.errors || addressForm.get('postalCode')?.invalid) &&
                    addressForm.get('postalCode')?.touched
                "
                class="text-red-500 text-xs mt-1"
                >
                Error: Enter a ZIP code.
            </div>
        </div>

        <div class="sm:col-span-2">

            <div class="mt-1">
                <input
                    type="text"
                    name="phoneNumber"
                    id="phoneNumber"
                    placeholder="Phone Number(required)"
                    formControlName="phoneNumber"
                    autocomplete="tel"
                    class="block w-full border-gray-300 rounded-md shadow-sm
                        focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                    [ngClass]="{ 'border-red-500': addressForm.get('phoneNumber')?.invalid && addressForm.get('phoneNumber')?.touched }"
                />
            </div>
            <div
                *ngIf="
                    addressForm.get('phoneNumber')?.errors?.phoneInvalid &&
                    addressForm.get('phoneNumber')?.touched
                "
                class="text-red-500 text-xs mt-1"
                >
                Error: Please enter a valid phone number.
            </div>
            <div class="text-gery-500 text-xs mt-1">
                We only use this number if there is a shipping issue.
            </div>
        </div>
    </div>
</form>
